import { combineReducers } from 'redux';
import { rolesReducer } from './reducers/roles-reducer';
import { applicationRolesReducer } from './reducers/application-roles-reducer';

export default combineReducers({
  rolesReducer,
  applicationRolesReducer
});
